<template>
  <AuthLayout>
    <template #title> Inscription </template>
    <template #subTitle> Renseignez vos infos pour continuer </template>
    <template #redirectQuestion> Déjà un compte? </template>
    <template #redirectLink>
      <router-link to="/login">Connectez-vous!</router-link>
    </template>
    <form
      class="space-y-6"
      v-bus:EVENTS.USER.REGISTER.submit.prevent
      v-redirect-on="{
        event: $constants.EVENTS.USER.REGISTER_SUCCESS,
        to: '/'
      }"
    >
      <!-- Nom et Prénom -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block mb-1 font-medium text-gray-700">Nom</label>
          <input
            name="lastName"
            type="text"
            required
            class="inputComponent"
            placeholder="Votre nom"
          />
        </div>
        <div>
          <label class="block mb-1 font-medium text-gray-700">Prénom</label>
          <input
            name="firstName"
            type="text"
            required
            class="inputComponent"
            placeholder="Votre prénom"
          />
        </div>
      </div>

      <!-- Téléphone -->
      <div>
        <label class="block mb-1 font-medium text-gray-700">Téléphone</label>
        <div class="flex gap-2">
          <select required name="phonePrefix" class="w-24! inputComponent">
            <option value="">+---</option>
            <option value="229">+229</option>
            <option value="228">+228</option>
            <option value="225">+225</option>
            <option value="226">+226</option>
            <option value="223">+223</option>
            <option value="241">+241</option>
            <option value="227">+227</option>
            <option value="221">+221</option>
          </select>
          <input
            name="phoneNumber"
            type="tel"
            required
            class="flex-1! inputComponent"
            placeholder="Votre numéro"
          />
        </div>
      </div>

      <!-- Email -->
      <div>
        <label class="block mb-1 font-medium text-gray-700">Email</label>
        <input
          name="email"
          type="email"
          required
          class="inputComponent"
          placeholder="email@exemple.com"
        />
      </div>

      <!-- Mot de passe -->
      <div>
        <label class="block mb-1 font-medium text-gray-700">Mot de passe</label>
        <input
          name="password"
          type="password"
          required
          class="inputComponent"
          placeholder="********"
        />
      </div>

      <!-- Code d'affiliation (optionnel) -->
      <div>
        <label class="block mb-1 font-medium text-gray-700"
          >Code d'affiliation</label
        >
        <input
          name="affiliationCode"
          type="text"
          class="inputComponent"
          placeholder="Optionnel"
        />
      </div>

      <!-- Numéro WhatsApp (optionnel) -->
      <div>
        <label class="block mb-1 font-medium text-gray-700"
          >Numéro WhatsApp</label
        >
        <input
          name="whatsappNumber"
          type="tel"
          class="inputComponent"
          placeholder="Optionnel"
        />
      </div>

      <!-- Cases à cocher -->
      <div class="space-y-3">
        <label class="flex items-center">
          <input
            name="acceptMoreThan18"
            type="checkbox"
            required
            class="mr-2"
          />
          <span class="text-sm">J'ai plus de 18 ans</span>
        </label>

        <label class="flex items-center">
          <input name="termOfUse" type="checkbox" required class="mr-2" />
          <span class="text-sm">
            J'accepte les
            <a
              href="https://web.{lacasaeBettingServiceName}.com/cgu"
              target="_blank"
              class="underline text-primary"
            >
              conditions d'utilisation
            </a>
          </span>
        </label>
      </div>

      <!-- Bouton continuer -->
      <button
        type="submit"
        class="buttonComponent w-full"
        :disabled="$stores?.user?.state?.loading"
        :loading="$stores?.user?.state?.loading"
      >
        S'inscrire
      </button>
    </form>
  </AuthLayout>
</template>
